import type React from 'react';

import { Icon } from '@gitbook/spine-icons';
import {
    Button,
    PageSplit,
    PageSplitAside,
    PageSplitBody,
    PageSplitHeader,
    PageSplitMain,
} from '@gitbook/spine-react';

import { ChurroAsideBg } from '../../Components/Onboarding/ChurroAsideBg';
import { DocsPreview } from '../../Components/Welcome/DocsPreview';

export function LoginScreenLayout(props: { children: React.ReactNode; onClose?: () => void }) {
    const { children, onClose } = props;

    return (
        <PageSplit>
            <PageSplitMain>
                {onClose ? (
                    <PageSplitHeader>
                        <Button
                            label="Back"
                            kind="secondary"
                            leadingIcon={Icon.ArrowLeft}
                            iconOnly
                            onPress={onClose}
                            className="m-4"
                        />
                    </PageSplitHeader>
                ) : null}
                <PageSplitBody size="medium">{children}</PageSplitBody>
            </PageSplitMain>
            <PageSplitAside
                className="overflow-visible"
                customGradient={<ChurroAsideBg kind="login" />}
            >
                <DocsPreview />
            </PageSplitAside>
        </PageSplit>
    );
}
